window.jQuery = window.jQuery || function () { };
window.$ = window.jQuery;
window.$.fn = window.$.fn || {};
window._ = window._ || {};
window.OneSignal = window.OneSignal || [];
window.dataLayer = window.dataLayer || [];
window.REFRESH = false;
window.URL_REDIRECT = null;
window.URL_REDIRECT_TYPE = null;
window.mouseX = null;
window.mouseY = null;
window.viewports = {
	sm: 768,
	md: 992
};

